import React from "react"
import classes from "./modal.module.scss"
// import Alink from "../UI/ALink/ALink"
import SectionTitle from "../UI/sectionTitle/sectionTitle"
import { FaPhone, FaEnvelope, FaLinkedin } from "react-icons/fa"

const Modal = props => {
  return (
    <div className={classes.Modal}>
      <div className={classes.Inner}>
        <SectionTitle titleType="GetInTouch">Kontaktai</SectionTitle>
        <div className={classes.wrapper}>
          <ul className={classes.ul}>
            <li className={classes.li}>
              <FaPhone className={classes.Icon} />
              <span className={classes.Span}>+37062070792</span>
            </li>
            <li className={classes.li}>
              <FaEnvelope className={classes.Icon} />
              <span className={classes.Span}> 1arnasdickus1@gmail.com</span>
            </li>
            <li className={classes.li}>
              <FaLinkedin className={classes.Icon} />
              {/*  
              <Alink
                href="https://www.linkedin.com/in/arnas-di%C4%8Dkus-a77b15162/"
                target="_blank"
                rel="noreferrer"
              >
                <span className={classes.Span}> Linkedin</span>
              </Alink>
              */}
            </li>
          </ul>
        </div>
      </div>
      <p className={classes.Close} onClick={props.CloseModal}>
        X
      </p>
    </div>
  )
}

export default Modal
